module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch6",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "aria-label": "8",
      "id": "pg_8",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch6",
      "id": "ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("Cleansing")])])])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "VSB"
  }, [_vm._v("I know my worth … now.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("My therapy sessions are paying off. There was")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("a time when I did not think I was worth two")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("corroded pennies rubbed together.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("My therapist claims this is normal.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("But, if I had to pinpoint a time")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("in my life when I felt as worthless")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("and as meaningless as hot dog scum—")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("yes, it’s real stuff")]), _vm._v("—it would be the awakening")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("my "), _c('i', [_vm._v("twenty-something-year-old-self")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("had while scrubbing 30-year-old, once-white")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("bathroom tile grout with a nail file at 3 a.m.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("While the babies and my husband slept, I")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("labored over the most ridiculous of tasks,")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("trying in vain to make")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("our helter-skelter lives pristine, Mayberryish")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("and fairytale like.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("I thought that bleach, Pine Sol,")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("and elbow grease could wash the pain away,")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("send the misery gurgling down the drain.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("In some twisted way, I hoped")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("the cleanliness I tried to impart")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("would wash the filth away from my soiled soul.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("I felt dirty … and used. Spoiled goods.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('span', {
    attrs: {
      "aria-label": "9",
      "id": "pg_9",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("I was dependent upon a man for my emotional")])]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("and physical stability.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("My lot in life was to please him, not rile him.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("Please him: always my thoughts were of")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("pleasing him.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("Make him happy. Keep him calm.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("The kids don’t need to hear him angry. He will")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("ignore them if he’s mad at me.")]), _vm._v(" He likes the")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("house clean.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("Clean … makes him … tolerable.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("The carpets require vacuum marks—just so.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("One direction. Unified. Back and forth.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("The bathroom should be immaculate. Wash and")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("shine shampoo bottles.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("Fold the towels just right. Creases left")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("and right.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("The tile must glow. The grout is old …")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("my fingers are raw and peeling. Droplets of")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("my blood are on the canvas. The bleach")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("burns … but scour, I will.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("I must prove to this man who thinks I’m")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("nothing that I have worth.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_c('span', {
    attrs: {
      "aria-label": "10",
      "id": "pg_10",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("I must justify my worthiness to myself.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("So, as I sat there on that cold tile, inhaling")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("bleach fumes, scrubbing")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("with bleeding fingers, "), _c('i', [_vm._v("and hating myself all")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("the while, knowing that my life was a")])]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_c('i', [_vm._v("delusional screwed-up mess.")])]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I had an awakening.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("I did not want to feel worthless anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I wanted it all to go away.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I wanted to start a new life. Begin again.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("Blink and make it all go away.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("Little did I know, it would take hundreds of")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("these self-awakening cleaning sprees before")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("I acquired the strength")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("to shake out my fearful feathers, and fly.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec84e26a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter6.vue
// module id = 87
// module chunks = 0